import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { MdOutlineAdminPanelSettings, MdLogout, MdDarkMode, MdLightMode } from 'react-icons/md';
import backOfficeRoutes from 'routesBackOffice';

export default function BackOfficeNavbar(props: { currentRoute: string }) {
    const { currentRoute } = props;
    const navigate = useNavigate();
    const [colorMode, setColorMode] = useState<'light' | 'dark'>('light');

    useEffect(() => {
        const stored = localStorage.getItem('chakra-ui-color-mode');
        if (stored === 'dark') setColorMode('dark');
    }, []);

    const toggleColorMode = () => {
        const newMode = colorMode === 'light' ? 'dark' : 'light';
        setColorMode(newMode);
        localStorage.setItem('chakra-ui-color-mode', newMode);
        document.documentElement.classList.toggle('dark');
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user-type');
        navigate('/auth/sign-in');
    };

    return (
        <div
            className="fixed top-0 left-0 right-0 z-[999] shadow-md"
            style={{
                background: colorMode === 'dark' ? '#1B254B' : 'white',
            }}
        >
            <div className="flex items-center justify-between px-[30px] py-[15px] max-w-full">
                {/* Left section - Logo & Title */}
                <div className="flex items-center gap-[15px]">
                    <MdOutlineAdminPanelSettings size={32} color="#4318FF" />
                    <div>
                        <div
                            className="text-xl font-bold"
                            style={{ color: colorMode === 'dark' ? 'white' : '#1B254B' }}
                        >
                            Back Office
                        </div>
                        <div
                            className="text-sm"
                            style={{ color: colorMode === 'dark' ? '#A0AEC0' : '#718096' }}
                        >
                            {currentRoute}
                        </div>
                    </div>
                </div>

                {/* Center section - Navigation */}
                <div className="flex gap-[20px] items-center">
                    {backOfficeRoutes
                        .filter((route: RoutesType) => route.menu)
                        .map((route: RoutesType, index: number) => (
                            <Link key={index} to={route.layout + route.path}>
                                <div
                                    className="flex items-center gap-[8px] px-[15px] py-[8px] rounded-[10px] cursor-pointer transition-all"
                                    style={{
                                        background: window.location.href.includes(
                                            route.layout + route.path
                                        )
                                            ? colorMode === 'dark'
                                                ? '#1B254B'
                                                : '#F7FAFC'
                                            : 'transparent',
                                        color:
                                            colorMode === 'dark'
                                                ? 'white'
                                                : '#1B254B',
                                    }}
                                    onMouseEnter={(e: React.MouseEvent<HTMLDivElement>) => {
                                        e.currentTarget.style.background =
                                            colorMode === 'dark' ? '#1B254B' : '#F7FAFC';
                                    }}
                                    onMouseLeave={(e: React.MouseEvent<HTMLDivElement>) => {
                                        if (
                                            !window.location.href.includes(
                                                route.layout + route.path
                                            )
                                        ) {
                                            e.currentTarget.style.background = 'transparent';
                                        }
                                    }}
                                >
                                    <div>{route.icon}</div>
                                    <div className="font-medium">{route.name}</div>
                                </div>
                            </Link>
                        ))}
                </div>

                {/* Right section - Actions */}
                <div className="flex gap-[10px] items-center">
                    <button
                        className="px-4 py-2 rounded-md hover:bg-blue-50 dark:hover:bg-navy-700 transition-all text-blue-600"
                        onClick={() => navigate('/admin')}
                    >
                        Exit Back Office
                    </button>
                    <button
                        className="px-4 py-2 rounded-md hover:bg-red-50 dark:hover:bg-navy-700 transition-all text-red-600 flex items-center gap-2"
                        onClick={handleLogout}
                    >
                        <MdLogout />
                        <span>Logout</span>
                    </button>
                </div>
            </div>
        </div>
    );
}
